module.exports = __webpack_public_path__ + "img/login-bg.14e5db54.png";